import { jsxs, jsx } from 'react/jsx-runtime';

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const HandLuggageIcon = (props)=>/*#__PURE__*/ jsxs("svg", _objectSpreadProps(_objectSpread({}, props), {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        children: [
            /*#__PURE__*/ jsxs("g", {
                clipPath: "url(#728cf3c1__clip0_3763_7)",
                children: [
                    /*#__PURE__*/ jsx("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M11.9 4.34097H4.1V13.9999H11.9V4.34097ZM13.1 13.9999C14.7561 13.999 16.0983 12.6562 16.0983 10.9999L16.0983 7.34098C16.0983 5.6847 14.7561 4.34191 13.1 4.34097V13.9999ZM6.12786e-06 7.34096C9.8693e-06 5.71758 1.28944 4.39536 2.9 4.34261V13.9983C1.28943 13.9456 -6.04645e-06 12.6233 -2.305e-06 10.9999L6.12786e-06 7.34096Z",
                        fill: props.fill
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M5.21565 3.42324L5.2085 3.52993H5.31543H5.91775H6.0093L6.01736 3.43873C6.10304 2.46921 6.94711 1.69267 7.96563 1.69267C8.98385 1.69267 9.82899 2.46917 9.9291 3.44018L9.93836 3.52993H10.0286H10.6309H10.739L10.7306 3.42213C10.6211 2.02111 9.41757 0.9 7.96563 0.9C6.51394 0.9 5.30961 2.0211 5.21565 3.42324Z",
                        fill: props.fill,
                        stroke: props.fill,
                        strokeWidth: 0.2
                    })
                ]
            }),
            /*#__PURE__*/ jsx("defs", {
                children: /*#__PURE__*/ jsx("clipPath", {
                    id: "728cf3c1__clip0_3763_7",
                    children: /*#__PURE__*/ jsx("rect", {
                        width: 16,
                        height: 16,
                        fill: "white"
                    })
                })
            })
        ]
    }));
HandLuggageIcon.defaultProps = {
    width: 16,
    height: 16,
    fill: 'currentColor'
};

export { HandLuggageIcon as default };
//# sourceMappingURL=HandLuggage.mjs.map
